<template>
    <Modal v-slot="{ close }">
        <div class="modal-header">
            <h4 class="modal-header__title modal-header__title--centered">Форма заказа</h4>
        </div>
        <div class="modal__body">
            <div class="modal-alerts" >
                <transition name="slide-up">
                    <div class="alert" :class="{ 'alert--success': status.success, 'alert--error': status.error }" v-if="(status.error || status.success) && status.message.length > 0" v-html="status.message" @click="status.error = false"></div>
                </transition>
            </div>
            <div class="form-group form-group--label-column">
                <input type="text" class="form-group__input" id="modal-order-name" v-model="form.name" autocomplete="off">
                <div class="form-group__label" :class="{'form-group__label--focus': form.name != ''}">Как мы можем к вам обращаться?</div>
            </div>
            <div class="form-group form-group--label-column">
                <input type="text" class="form-group__input" id="modal-order-email" v-model="form.email" autocomplete="off">
                <div class="form-group__label" :class="{'form-group__label--focus': form.email != ''}">E-mail для обратной связи</div>
            </div>
            <div class="form-group form-group--label-column">
                <input type="text" class="form-group__input" id="modal-order-phone" v-model="form.phone" autocomplete="off">
                <div class="form-group__label" :class="{'form-group__label--focus': form.phone != ''}">Ваш телефон</div>
            </div>
            <div class="form-group">
                <textarea class="form-group__textarea" id="modal-order-comment" v-model="form.comment"></textarea>
                <div class="form-group__label" :class="{'form-group__label--focus': form.comment != ''}">Комментарий к заказу</div>
            </div>
            <div class="form-group">
                <div class="modal-buttons__file-wrap">
                    <button type="button" class="btn modal-buttons__btn modal-buttons__btn--file" @click="onSelectFile">
                        <svg-symbol name="add-file" class="modal-file__icon"></svg-symbol>
                        <span>Файлы для загрузки</span>
                    </button>
                    <input type="file" class="d-none" ref="refFile" @change="changeFile" multiple/>
                </div>
                <div class="modal-files" v-if="form.files.length">
                    <div class="modal-file" v-for="(file, index) in form.files" :key="index">
                        <div class="modal-file__text" v-html="`${index + 1}. ${file.name}`"></div>
                        <div class="modal-file__remove" @click="removeFile(index)"></div>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <input type="checkbox" id="modal-order-checkbox" class="modal-checkbox" v-model="form.agreement"><label for="modal-order-checkbox" class="modal__description">Я даю своё согласие на обработку моих персональных данных в соответствии с Федеральным законом от 27.07.2006 года 152-ФЗ О персональных данных, на условиях и для целей, определенных <a href="/policy/policy.pdf" title="Политика конфиденциальности" target="_blank">политике конфиденциальности</a>.</label>
            </div>
            <div class="modal-buttons">
                <button type="button" class="btn modal-buttons__btn" v-html="status.sending ? (status.totalPercent || 'Отправляем данные') : 'Отправить'" @click="sendForm"></button>
            </div>
        </div>
    </Modal>
</template>

<script>
export default {
    name: "modal-order",
};
</script>

<script setup>
import { ref, watch } from 'vue';
import axios from 'axios';
import Modal from '@js/components/ui/modals/modal';
import SvgSymbol from '@js/components/ui/svg-symbol';

const emits = defineEmits(['close']);
const props = defineProps({
    items: {
        type: [Array, Object]
    }
})

const status = ref({
    message: '',
    error: null,
    success: null,
    sending: null,
    totalPercent: null,
})

const form = ref({
    name: '',
    email: '',
    phone: '',
    comment: '',
    agreement: false,
    files: [],
});

const refFile = ref(null);

const onSelectFile = () => {
    refFile.value.click();
};

const changeFile = (event) => {
    const files = event.target.files || event.dataTransfer.files;
    
    if (!files.length) {
        return;
    }

    form.value.files = Array.prototype.slice.call(files, 0, 5);
};

const removeFile = (index) => {
    form.value.files = form.value.files.filter((item, itemIndex) => itemIndex !== index);
}

const sendForm = async () => {
    status.value.error = null;
    status.value.success = null;

    try {
        ym(40463360, 'reachGoal', 'preOrderLead');
    } catch(e) {
        console.error(e);
    }

    if (form.value.email == '') {
        status.value.error = true;
        status.value.message = 'Вы не заполнили e-mail!';
        document.querySelector("#modal-order-email").focus();
        return;
    }

    if (form.value.phone == '') {
        status.value.error = true;
        status.value.message = 'Вы не заполнили телефон!';
        document.querySelector("#modal-order-phone").focus();
        return;
    }

    if (! form.value.agreement) {
        status.value.error = true;
        status.value.message = 'Вы не согласились с условиями политики конфиденциальности';
        return;
    }
    
    if (! status.value.sending) {
        status.value.sending = true;

        let data = {
                form: {
                    name: form.value.name,
                    email: form.value.email,
                    phone: form.value.phone,
                    comment: form.value.comment,
                    itemComments: props.items.map(item => item.comment || ''),
                    agreement: form.value.agreement,
                },
                _token: document.querySelector('meta[name="csrf"]')?.getAttribute('content')
            },
            headers = { "Content-Type": "application/json" },
            onUploadProgress = () => {};


        if (form.value.files.length) {
            headers = { "Content-Type": "multipart/form-data" };
            const formData = new FormData();
            formData.append("form[name]", data.form.name);
            formData.append("form[email]", data.form.email);
            formData.append("form[phone]", data.form.phone);
            formData.append("form[comment]", data.form.comment);
            formData.append("form[agreement]", data.form.agreement ? 1 : 0);
            
            let i = 0;
            for (let file of form.value.files) {
                formData.append(`form[files][${i++}]`, file, file.name);
            }

            for (let i in data.form.itemComments) {
                formData.append(`form[itemComments][${i}]`, data.form.itemComments[i]);
            }

            formData.append("_token", document.querySelector('meta[name="csrf"]')?.getAttribute('content'));
            data = formData;
            
            onUploadProgress = ProgressEvent => {
                status.value.totalPercent = 'Загружено ' + Math.round(
                    (ProgressEvent.loaded * 100) / ProgressEvent.total
                ) + '%';
            }

        }
        
        await axios
            .post("/cart/order", data, { headers: headers, onUploadProgress: onUploadProgress })
            .then(() => {
                try {
                    ym(40463360, 'reachGoal', 'orderlead');
                } catch(e) {
                    console.error(e);
                }
                status.value.sending = null;
                window.location = '/cart';
            })
            .catch((error) => {
                status.value.success = null;
                status.value.totalPercent = null;
                if (error.response?.data.errors) {
                    for (let key in error.response.data.errors) {
                        document.querySelector("#modal-order-" + key.replace('form.', '').replace('files.', 'files-'))?.focus();
                        status.value.message = error.response.data.errors[key].join('<br>');
                        break;
                    }
                } else {
                    status.value.message = error.response?.data.message || error.message;
                    if (error.response?.data.focus) {
                        document.querySelector("#modal-order-" + error.response.data.focus)?.focus();
                    }
                }
                status.value.sending = null;
                status.value.error = true;
            });
    }

}

const close = () => {
    emits('close');
}

</script>